import * as React from "react";
import styled, { css } from "styled-components";

import { Text } from "src/library/components/Text";
import { Tooltip } from "src/library/components/Tooltip";
import { IOrderLine } from "src/core/orders/api/orders.api";
import { IListLine } from "src/core/lists/api/lists.api";
import { formatPrice } from "src/core/prices/utils/price-helpers";

import { calculateCartTotal } from "../../orders/utils/orders";

interface PriceProps {
  id: number;
  lines: IOrderLine[] | IListLine[];
  // only return the total
  totalOnly?: boolean;
  // optionally passed for table data: discount
  discountValue?: number;
  currency?: string
}

/**
 * Component for displaying a product price
 *
 * @param {*} { product, quantity, installedModules, currency, type, mode, line }
 * @returns
 */
export const TotalPrice: React.ReactFCWithChildren<PriceProps> = ({
  lines, id, totalOnly, discountValue, currency
}) => {
  const tippyId = `${id}-tooltip`;

  const price = React.useMemo(() => {
    return calculateCartTotal(lines, discountValue).discounted || calculateCartTotal(lines);
  }, [ discountValue, lines ]);

  return (
    <PriceWrapper>
      <Text className="current-price">
        {price && formatPrice(price.total, 2, currency)}
      </Text>

      {!!price?.vat && !totalOnly && (
        <>
          <div
            className="total-vat-wrapper"
            data-tip
            data-for={tippyId}
          >
            <Text
              className="inc-vat"
              fontSize="sub"
            >
              {" inc. VAT"}
            </Text>
          </div>

          <Tooltip
            id={tippyId}
            type="dark"
            place="left"
            getContent={() => {
              return (
                <>
                  <Text color="white">
                    {"Price: "}

                    {formatPrice(price.net, 2, currency)}
                  </Text>

                  <br />

                  <Text color="white">
                    {"VAT: "}

                    {formatPrice(price.vat, 2, currency)}
                  </Text>
                </>
              );
            }}
          />
        </>
      )}
    </PriceWrapper>
  );
};

const PriceWrapper = styled.span`
  ${() => css`
    .inc-vat:hover {
      cursor: help;
    }
  `}
`;
